// combatpro/panels/monsters/studio/MonsterStudioLibraryList.js
//
// Combat PRO - MonsterStudioLibraryList (Stage 57: Library Runtime Foundation).
//
// Renders the #vi-st-liblist content from runtime-generated items - the React
// equivalent of the legacy viStudioRenderLibrary output (battletracker.html
// 11198-11209). The count header (with the "(showing 300)" cap note), the item
// buttons (icon / name / sub), and the "No monsters match." empty message are
// reproduced verbatim. The runtime owns list generation; this component only
// renders and routes clicks to onPick(kind, key). No HTML is built manually; no
// DOM access. No optional chaining. No em dash.

import React from 'react';

function MonsterStudioLibraryList(props) {
  var count = props.count;
  var items = Array.isArray(props.items) ? props.items : [];
  var capped = props.capped;

  return (
    <div className="vi-st-liblist" id="vi-st-liblist">
      <div className="vi-st-libcount">
        {count} monster{count === 1 ? '' : 's'}{capped ? ' (showing 300)' : ''}
      </div>
      {items.map(function(it, i) {
        var icon = it.kind === 'official' ? '\ud83d\udcd6' : '\u2b50';
        return (
          <button
            className="vi-st-libitem"
            type="button"
            key={it.kind + '-' + it.key + '-' + i}
            onClick={function() { props.onPick(it.kind, it.key); }}
          >
            <span className="vi-st-libicon">{icon}</span>
            <span className="vi-st-libname">{it.name}</span>
            <span className="vi-st-libsub">{it.sub}</span>
          </button>
        );
      })}
      {items.length === 0 ? <div className="vi-st-libempty">No monsters match.</div> : null}
    </div>
  );
}

export default MonsterStudioLibraryList;
